export default __webpack_public_path__ + "static/media/EXP.317878ad.svg";